// extracted by mini-css-extract-plugin
export default {"KflSyntaxReferenceContainer":"StartRecordingJobView_KflSyntaxReferenceContainer__4huoQ","KflQueryFieldContainer":"StartRecordingJobView_KflQueryFieldContainer__HH2t6"};